/* eslint-disable no-unused-vars */
function resolveRefs(document) {
  const regex = /^#\/([a-zA-Z0-9-_/]+)$/;
  // check for loops
  let preValueResolved;
  const resolveRef = (obj, ref) => {
    const match = ref.match(regex);

    if (match) {
      const parts = match[1].split('/');
      let value = obj;
      for (const part of parts) {
        value = value[part];
      }
      if (value === preValueResolved) {
        return '';
      } else {
        preValueResolved = value;
        return value;
      }
    }
    if (ref !== '') {
      console.log('Error in spec with' + ref);
    }
    return '';
  };

  const resolve = (obj) => {
    //  limit the loop in loop error
    let prevalue, preRef;
    if (typeof obj === 'object' && obj !== null) {
      if ('$ref' in obj && preRef !== obj['$ref']) {
        preRef = obj['$ref'];
        const refValue = resolveRef(document, obj['$ref']);
        if (refValue !== '' && prevalue !== refValue) {
          prevalue = resolve(refValue);
          return prevalue;
        } else {
          // console.log('loop in ' + obj['$ref']);
          return;
        }
      } else {
        for (const key in obj) {
          obj[key] = resolve(obj[key], key);
        }
      }
    }

    return obj;
  };

  return resolve(document);
}

const removeProptype = (json) => {
  const jsonStr = JSON.stringify(json);
  let jsonObj = JSON.parse(jsonStr);
  let newObj = {};

  for (let prop in jsonObj) {
    // eslint-disable-next-line no-prototype-builtins
    if (jsonObj.hasOwnProperty(prop) && prop !== '__proto__') {
      newObj[prop] = jsonObj[prop];
    }
  }

  let newJsonStr = JSON.parse(JSON.stringify(newObj));
  return newJsonStr;
};
export { resolveRefs, removeProptype };
